module.exports = __webpack_public_path__ + "img/tx.3f24e9e5.png";